// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dhM2mZz6I_dsOfSfR3OE{background:var(--content-primary-primary-inverted);justify-content:space-between;align-items:center;gap:16px;width:100%;max-width:760px;margin:0 auto;padding:8px 20px;display:flex}.wVXACvlHmeIBTSlxMtHX{margin-right:auto}.Gfk6RfNQU24GldWvWXyM{flex-direction:column;align-items:flex-end;gap:16px;width:-webkit-max-content;width:max-content;margin-left:auto;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `dhM2mZz6I_dsOfSfR3OE`,
	"left": `wVXACvlHmeIBTSlxMtHX`,
	"right": `Gfk6RfNQU24GldWvWXyM`
};
export default ___CSS_LOADER_EXPORT___;
